var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M15.92 7.76c.053.053.08.133.08.24a.71.71 0 0 1-.08.32l-7.6 7.6c-.053.053-.133.08-.24.08-.107 0-.2-.04-.28-.12a.384.384 0 0 1-.12-.28.71.71 0 0 1 .08-.32l6.88-6.88H.4c-.107 0-.2-.04-.28-.12a.384.384 0 0 1 0-.56C.2 7.64.293 7.6.4 7.6h14.24L7.76.72C7.653.613 7.6.507 7.6.4c0-.107.04-.2.12-.28.08-.08.187-.12.32-.12s.227.027.28.08l7.6 7.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next_icon.0e35486605e5f3755284a5e3693bc9c4.svg";
export { ForwardRef as ReactComponent };